<template>
  <div>
    <div class="main-content" v-if="!hardRefresh">
      <div class="card">
        <div class="card-header" v-if="!extraOptions?.hide?.newOrderHeader">
          <h5>Новая заявка
            <button type="button" @click="initiateOrder" class="btn btn-info">сбросить</button>
          </h5>
          <p v-if="savedOrderId">Заявка <strong>{{ savedOrderId }}</strong> создана</p>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <SelectProjectCity
                ref="ProjectCitySelect"
                :customData="{disableProjectSelect: extraOptions?.disable?.projectSelect}"
                :onUpdate="(data) => this.updateLocality(data)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>Клиент</h5>
        </div>
        <div class="card-body">
          <SelectClient ref="clientData"/>
        </div>
      </div>

      <template v-if="outsourceStore">
        <div class="card mb-1">
          <div class="card-header">
            <h5>Поиск препаратов</h5>
          </div>
          <div class="card-body">
            <NewOutsourceOrder
              :clearOutsourceStore="(drug) => clearOutsourceStore(drug)"
              :clientData="{client: $refs.clientData.client, phones: $refs.clientData.phones}"
              :companyId="outsourceStore"
            />
          </div>
        </div>
      </template>

      <template v-if="!outsourceStore">
        <div class="card">
          <div class="card-header">
            <h5>Препараты</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <template v-if="$editNewOrder.site_id">
                  <div v-for="(drug, index) in drugsInOrder" class="drugSelected" :key="drug.id">
                    <!--                      :ref="`search_drug_${index}`"-->
                    {{ drug?.id }}
                    <DrugSelect
                      ref="SelectedDrug"
                      :selectedDrug="drug"
                      searchType="1"
                      :onSelect="(d) => updateDrugData(d, index)"
                      :updateDeliveryDate="checkDeliveryDate"
                    />
                    <div class="send_drug_btn_block" v-if="sendDrugMessage">
                      <button @click="() => sendDrugMessage(drugsInOrder[index])" class="btn btn-outline-info btn-xs">
                        Отправить
                        препарат в чат
                      </button>
                    </div>
                  </div>
                  <div class="drugSelected">
                    <DrugSelect
                      ref="newDrug"
                      searchType="1"
                      :onSelect="(d) => updateDrugData(d, drugsInOrder.length)"
                    />
                  </div>
                </template>
                <template v-else>
                  <h4>Выберите сначала проект для выбора препаратов</h4>
                </template>
              </div>
              <div class="col-md-4">
                <OrderPriceDetails ref="OrderPriceDetails"/>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="flex">
              <ReserveOrder ref="ReserveOrder"/>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h5>Доставка</h5>
          </div>
          <div class="card-body">
            <div v-if="deliveryDateWarning">
              <RecommendedDeliveryDate
                :deliveryDate="$refs.DeliveryData?.deliveryDate"
                :cityId="currentLocality.city_id"
              />
            </div>
            <DeliveryData
              ref="DeliveryData"
              :checkDeliveryDate="checkDeliveryDate"
            />
          </div>
        </div>
        <div>
          <CommentBlock ref="commentBlock"/>
        </div>
        <div class="card">
          <div class="card-body flex justify-content-between">
            <div/>
            <div>
              <LoadingButton
                title="Клиента не устраивает срок доставки"
                className="btn btn-outline-warning"
                :loading="loadingBtn"
                :onClick="() => saveOrder(false, false, false, true)"
              />
              <LoadingButton
                title="Отметить заявку как спрос"
                className="btn btn-outline-info"
                :loading="loadingBtn"
                :onClick="() => saveOrder(true)"
              />
              <template v-if="allowToPassDelivery">
                <LoadingButton
                  title="Создать заявку<br>и передать на МЛ"
                  className="btn btn-success"
                  :color="$constants.SUCCESS_COLOR"
                  :loading="loadingBtn"
                  :onClick="() => saveOrder(false, true)"
                />
              </template>
              <template v-else>
                <LoadingButton
                  v-if="!$editNewOrder.id && extraOptions?.savePreOrder"
                  title="Создать предварительную заявку"
                  className="btn btn-outline-success"
                  color="white"
                  :loading="loadingBtn"
                  :onClick="() => saveOrder(false, false, true)"
                />
                <LoadingButton
                  title="Создать заявку"
                  className="btn btn-success"
                  color="white"
                  :loading="loadingBtn"
                  :onClick="() => saveOrder()"
                />
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import SelectProjectCity from '@/components/orders/SelectProjectCity'
import SelectClient from '@/components/clients/SelectClient'
import DrugSelect from '@/components/drugs/DrugSelectForOrder'
import OrderPriceDetails from '@/components/orders/OrderPriceDetails'
import DeliveryData from './components/DeliveryData'
import CommentBlock from './components/CommentsBlock'
import LoadingButton from '@/components/buttons/LoadingButton'
import {fillOrderBus} from "@/eventsBus";
import moment from "moment";
import NewOutsourceOrder from "@/views/orders/NewOutsourceOrder";
import RecommendedDeliveryDate from "@/views/orders/components/RecommendedDeliveryDate.vue";
import ReserveOrder from "@/components/orders/ReserveOrder.vue";

export default {
  props: ['orderToEdit', 'extraOptions', 'sendDrugMessage'],
  title: 'Новая заявка',
  components: {
    RecommendedDeliveryDate,
    ReserveOrder,
    NewOutsourceOrder,
    SelectProjectCity,
    SelectClient,
    DrugSelect,
    OrderPriceDetails,
    DeliveryData,
    CommentBlock,
    LoadingButton,
  },
  data() {
    return {
      deliveryDateWarning: null,
      tempPass: 12,
      outsourceStore: null,
      allowToPassDelivery: false,
      savedOrderId: null,
      hardRefresh: false,
      order: {},
      currentLocality: {},
      loadingBtn: false,
      drugsInOrder: [],
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  watch: {
    '$editNewOrder': {
      handler: function (val, oldVal) {
        this.updateOutsourceStore()
      },
      deep: true
    },
  },
  created() {
    if (this.$route.params && this.$route.params.extra_data) {
      const data = {
        drugId: this.$route.params.drugId,
        city_id: this.$route.params.extra_data.city_id,
        site_id: this.$route.params.extra_data.project_id,
        mirror_id: this.$route.params.extra_data.mirror_id,
        phone_call_id: this.$route.params?.phoneCallId,
        phone: '+' + this.$route.params.phoneNum
      }
      this.initiateOrder(data)
    } else {
      this.initiateOrder()
    }

    fillOrderBus.$on(
      "updateFillOrder",
      (data = {}) => {
        console.log(data, '----update');
        this.initiateOrder({
          drugId: data.drugId,
          city_id: data.extra_data?.city_id,
          site_id: data.extra_data?.project_id,
          mirror_id: data.extra_data?.mirror_id,
          client_name: data.client?.name,
          phone_call_id: data.phoneCallId,
          phone: data.phoneNum ? '+' + data.phoneNum : null,
        });
        this.$refs.clientData?.initiateClient();
      }
    );
  },
  beforeDestroy() {
    fillOrderBus.$off("updateFillOrder");
  },
  methods: {
    async checkDeliveryDate() {
      this.deliveryDateWarning = null;
      await this.$nextTick();
      (this.$refs.SelectedDrug ?? []).forEach((sd) => {
        if (+sd.qty <= (sd.$refs.drugInfo?.actualStoreQty || 0)) return;
        this.deliveryDateWarning = true;
      })
    },
    clearOutsourceStore(drug) {
      this.outsourceStore = null;
      setTimeout(() => {
        this.$refs.newDrug.updateDrug(drug);
      }, 300)
    },
    updateOutsourceStore() {
      this.outsourceStore = null;
      if (!this.drugsInOrder.length && +this.$editNewOrder.site_id === 14) {
        this.outsourceStore = 1;
      }
    },
    async initiateOrder(data = null) {
      console.log(data);
      await this.$store.dispatch('orders/setEditNewOrder', {
        id: null,
        city_id: 0,
        site_id: 0,
        price: 0,
        phone_call_id: data?.phone_call_id ?? null,
        phone: data?.phone ?? data?.phoneNum ?? null,
        division_id: 1,
        delivery_price: 0,
        discount: 0,
        // delivery_date: moment().add(1, 'days').format('YYYY-MM-DD'),
        discount_type: 0,
        client_name: data?.client_name || null,
        extra_options: {
          salary_rate: 0,
          call_day_before: true,
          call_hour_before_delivery: true,
          possible_early: false,
        },
        drugs: [{}]
      })
      if (this.$refs.clientData) {
        this.$refs.clientData.resetClient();
      }
      if (this.$refs.DeliveryData) {
        this.$refs.DeliveryData.resetData();
      }
      if (data) {
        if (this.$refs.ProjectCitySelect) {
          this.$refs.ProjectCitySelect.city = data.city_id + ''
          this.$refs.ProjectCitySelect.project = data.site_id + ''
          this.$refs.ProjectCitySelect.mirror = data.mirror_id + ''
        }
        this.$refs.clientData?.phoneValidate({e164: data.phone}, 0, true)
        this.updateLocality(data)
        this.$editNewOrder.delivery_date = moment(this.$refs?.DeliveryData?.deliveryDate).format('YYYY-MM-DD')
      }
      this.drugsInOrder = []
      if (data?.drugId) {
        setTimeout(async () => {
          await this.$refs.newDrug.$refs.searchDrug.onSearchDrug(data.drugId, false);
          setTimeout(() => {
            this.$refs.newDrug.$refs.searchDrug.onSelect(this.$refs.newDrug.$refs.searchDrug.options[0]);
          }, 500);
        }, 100)
      }
      this.updateCustomData();
    },
    updateDrugData(drug, index) {
      // console.log('drug updated by index', drug, index);
      if (!drug || !drug.qty) {
        delete this.drugsInOrder[index]
        this.drugsInOrder = this.drugsInOrder.filter(d => d)
      } else {
        if (!this.drugsInOrder[index]) {
          const selectedDrugId = this.drugsInOrder.map((d) => d.id)
          if (selectedDrugId.includes(drug.id)) return
          this.$refs.newDrug.drug = null
          this.drugsInOrder.push(drug)
        } else {
          this.drugsInOrder[index] = drug
        }
      }
      this.drugsInOrder = [...this.drugsInOrder];
      this.$editNewOrder.drugs = [...this.drugsInOrder];
      this.$refs.OrderPriceDetails.updatePrice();
    },
    updateCustomData() {
      this.allowToPassDelivery = +this.$editNewOrder.site_id === 12;
    },
    updateLocality(data) {
      this.$editNewOrder.city_id = data.city_id
      this.$editNewOrder.site_id = data.site_id
      this.$editNewOrder.site_mirror_id = data.mirror_id
      this.currentLocality = data
      this.updateCustomData();
      this.checkDeliveryDate();
    },
    validateOrder() {
      if (+this.$editNewOrder.city_id === -1 || this.$editNewOrder.city_id === null) {
        toastr['warning']('Укажите город!')
        return false
      }
      return true
    },
    async saveOrder(asRequest = false, passToDelivery = false, preOrder = false, notAcceptDeliveryDate = false) {
      if (!this.validateOrder()) return
      if (asRequest) {
        this.$editNewOrder.status = 8
      }
      if (notAcceptDeliveryDate) {
        this.$editNewOrder.status = -2;
        this.$editNewOrder.reject_type_id = 1;
      }
      this.loadingBtn = true
      const comments = await this.$refs.commentBlock.getUnsavedComment()
      this.$editNewOrder.comment = comments.comment

      const drugs = this.$refs.SelectedDrug.reduce((acc, d) => {
        if (!d?.drug?.id) return acc;
        acc.push({
          id: d.drug.id,
          title: d.drug.title,
          pack_set: d.drug.pack_set,
          combined_type: d.drug.combined_type,
          qty: d.drug.qty,
          actual_price: d.drug.actual_price,
          currency_price: d.drug.currency_price,
          extra_data: d.drug?.extra_data,
        })
        return acc;
      }, []);
      this.$editNewOrder.extra_options.comments_for_runner = comments.comments_for_runner
      const {data} = await api.post('/new/orders/createOrder', {
        client: this.$refs.clientData.client,
        phones: this.$refs.clientData.phones,
        order: {...this.$editNewOrder, drugs, currencyData: this.$refs.OrderPriceDetails.currencyData},
        chatBotDialogId: this.extraOptions?.chatBotDialogId,
        passToDelivery,
        preOrder
      })
      if (data.success) {
        toastr['success']('Сохранено!')
        this.hardRefresh = true
        if (this.$refs.ReserveOrder.saveAfterOrderUpdate) {
          this.$editNewOrder.id = data.orderId;
          await this.$refs.ReserveOrder.saveReserve()
        }
        await this.initiateOrder()
        this.savedOrderId = data.orderId
        this.hardRefresh = false
      } else {
        toastr['warning'](data.message || 'Ошибка!')
      }
      this.loadingBtn = false
    }
  }
}

</script>

<style scoped>
.card {
  margin-bottom: 10px;
}

.drugSelected {
  border: 1px solid lightgray;
  padding: 10px;
  margin-bottom: 10px;
  position: relative;
}

.card .card-header h6,
.card .card-header h5 {
  font-weight: 700;
}

.card .card-body {
  background-color: #f8f8f8 !important;
}

.send_drug_btn_block {
  position: absolute;
  right: 10px;
  top: 105px;
}
</style>
